/**
 * yearPanel.jsx
 *
 * @Author: apple
 * @Date: 2017/10/25 19:27
 */

import React, { Component } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import Button from '../../button';

/**
 * @ignore
 * */
class YearPanel extends Component {
  static propTypes = {};

  static defaultProps = {};

  handleSelect = value => e => {
    e.stopPropagation();
    const { selectType, onValueChange, onPanelTypeChange, onPanelDateChange } = this.props;
    if (selectType === 'year') {
      onValueChange(value);
    } else {
      onPanelTypeChange('month');
    }
    onPanelDateChange(value);
  };

  render() {
    const { value, panelDate, disabledYear, prefixCls, rangeType } = this.props;
    const isRange = Array.isArray(value);
    const start = moment(panelDate).subtract((panelDate.year() % 10) + 1, 'year');
    return (
      <tbody className={`${prefixCls}-body`}>
        {[0, 1, 2, 4].map((_, index) => (
          <tr key={index}>
            {[0, 1, 2].map((y, yearIndex) => {
              let selected = false;
              const year = yearIndex + 3 * index;
              const item = moment(start).add(year, 'year');
              if (isRange && rangeType === 'start') {
                selected = value[0] && item.isSame(value[0], 'year');
              } else if (isRange && rangeType === 'end') {
                selected = value[1] && item.isSame(value[1], 'year');
              } else {
                selected = value && item.isSame(value, 'year');
              }
              const disabled = disabledYear && disabledYear(item);
              const classes = classNames(`${prefixCls}-year-item`, {
                [`${prefixCls}-year-item-selected`]: selected,
                [`${prefixCls}-year-item-disabled`]: disabled,
              });
              const cellClasses = classNames(`${prefixCls}-year-cell`);
              return (
                <td key={year} className={cellClasses}>
                  <Button
                    className={classes}
                    onClick={this.handleSelect(item)}
                    disabled={disabled}
                    shape="none"
                    type={year === 0 || year === 1 ? 'secondary' : null}>
                    {item.year()}
                  </Button>
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    );
  }
}

export default YearPanel;



// WEBPACK FOOTER //
// ./src/datePicker/panel/YearPanel.jsx